"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
var _popoverArrow = _interopRequireDefault(require("./popover-arrow"));
class Popover extends _react.default.Component {
  constructor(props) {
    var _context;
    super(props);
    this.state = {};
    this.setPopoverEl = (0, _bind.default)(_context = this.setPopoverEl).call(_context, this);
  }
  setPopoverEl(element) {
    this.setState({
      popoverEl: element
    });
  }
  getStyleValues() {
    // The height of the arrow coming out of the popover, in px
    let arrowHeight = 12;
    // The gap between the tip of the arrow and the bottom of the trigger, in px
    let arrowGap = 5;
    // The amount of shadow under the popover, in material-ui elevation
    let elevation = 8;

    // The arrow is made by rotating a square 45 degrees
    // This is the side length of that square
    let arrowSideLength = Math.sqrt(2 * Math.pow(arrowHeight, 2));
    return {
      arrowGap: arrowGap,
      arrowHeight: arrowHeight,
      arrowSideLength: arrowSideLength,
      elevation: elevation
    };
  }
  render() {
    const {
      children,
      open,
      targetEl,
      showArrow,
      'data-testid': dataTestId,
      ...otherProps
    } = this.props;
    let styling = this.getStyleValues();
    return /*#__PURE__*/_react.default.createElement("span", null, showArrow && /*#__PURE__*/_react.default.createElement(_popoverArrow.default, {
      "data-testid": `${dataTestId}-arrow`,
      anchorEl: targetEl,
      popoverEl: this.state.popoverEl,
      arrowGap: styling.arrowGap,
      arrowHeight: styling.arrowHeight,
      arrowSideLength: styling.arrowSideLength,
      elevation: styling.elevation,
      open: open
    }), /*#__PURE__*/_react.default.createElement(_styles.OffsetPopover, (0, _extends2.default)({
      "data-testid": dataTestId,
      anchorEl: targetEl,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      elevation: styling.elevation,
      open: open,
      popoverOffset: styling.arrowHeight + 'px',
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, otherProps), /*#__PURE__*/_react.default.createElement("span", {
      ref: this.setPopoverEl
    }, children)));
  }
}
Popover.propTypes = {
  /**
   * The styled contents of the popover.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Whether or not the popover is open.
   */
  open: _propTypes.default.bool,
  /**
   * The element that is the anchor for the popover.
   * It can be undefined initially but it must be an object if open is true.
   */
  targetEl: function (props, propName, componentName) {
    if (props[propName] && typeof props[propName] !== 'object') {
      return new Error('Invalid prop `' + propName + '` of type `' + typeof props[propName] + '` supplied to `' + componentName + '`, expected `object`');
    }
    if (props['open'] && !props[propName]) {
      return new Error('Invalid prop configuration: `' + propName + '` must be defined if `open` is true');
    }
  },
  /**
   * Determines whether or not the arrow will be shown above the popover.
   * Default is true. Set to false if arrow is not displaying correctly.
   */
  showArrow: _propTypes.default.bool,
  'data-testid': _propTypes.default.string
};
Popover.defaultProps = {
  open: false,
  showArrow: true
};
var _default = exports.default = Popover;
Popover.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "setPopoverEl",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "element",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getStyleValues",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Popover",
  "props": {
    "open": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether or not the popover is open.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "showArrow": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Determines whether or not the arrow will be shown above the popover.\nDefault is true. Set to false if arrow is not displaying correctly.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "description": "The styled contents of the popover.",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "targetEl": {
      "description": "The element that is the anchor for the popover.\nIt can be undefined initially but it must be an object if open is true.",
      "type": {
        "name": "custom",
        "raw": "function (props, propName, componentName) {\n  if (props[propName] && typeof props[propName] !== 'object') {\n    return new Error(\n      'Invalid prop `' +\n        propName +\n        '` of type `' +\n        typeof props[propName] +\n        '` supplied to `' +\n        componentName +\n        '`, expected `object`'\n    );\n  }\n  if (props['open'] && !props[propName]) {\n    return new Error(\n      'Invalid prop configuration: `' +\n        propName +\n        '` must be defined if `open` is true'\n    );\n  }\n}"
      },
      "required": false
    },
    "data-testid": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};